/* ============================================================
   LOW KEY PARTS - extras
   1. Homepage "Top Sellers" switch to best-selling parts that fit the truck in My Garage
   2. Cart drawer "You may also need" add-ons (fitment-checked against My Garage)
   3. Phone footer: link columns collapse into tap-to-open sections
   Loaded from layout/theme.liquid after garage.js. Needs window.LKFilter + window.LKGarage.
   ============================================================ */
(function () {
  'use strict';

  /* -- helpers -- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function thumb(url, w) {
    if (!url) return '';
    url = String(url).replace(/([?&])width=\d+/, '$1width=' + w);
    return /[?&]width=/.test(url) ? url : url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function activeVehicle() {
    var v = window.LKGarage && window.LKGarage.getActive ? window.LKGarage.getActive() : null;
    return v && v.year && v.make && v.model ? v : null;
  }
  function vehicleLabel(v) { return [v.year, v.make, v.model].join(' '); }
  // 'verified' | 'suggested' | null (doesn't fit)
  function fitOf(p, v) {
    if (!window.LKFilter || !window.LKFilter.productFitmentBadge) return null;
    var s = window.LKFilter.productFitmentBadge(p.title, p.tags || [], v.year, v.make, v.model, v.engine || '', p.type, p.vendor);
    return s && s.matches ? s.confidence : null;
  }
  function typeKey(p) { return String(p.type || '').toLowerCase().trim(); }
  // "24-up" / "24-Up" means 2024 and newer: rewrite it as "24+" so the year parser reads it
  function upYears(title) { return String(title || '').replace(/(\d{2,4})\s*-\s*up\b/gi, '$1+'); }

  // Best-selling products of a collection, via the theme's lk-data view (100 per page, includes tags)
  var pageCache = {};
  function bestSellerPage(handle, page) {
    var key = handle + ':' + page;
    if (!pageCache[key]) {
      pageCache[key] = fetch('/collections/' + encodeURIComponent(handle) + '?view=lk-data&sort_by=best-selling&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) { return { products: d.products || [], next: d.next }; });
      pageCache[key].catch(function () { delete pageCache[key]; });
    }
    return pageCache[key];
  }

  /* -- 1. Vehicle-aware Top Sellers -- */
  var TOP_COUNT = 8, TOP_PER_TYPE = 2, TOP_MAX_PAGES = 3;

  function topCard(p, conf) {
    var sale = p.compare > p.price;
    var ok = conf === 'verified';
    return '<div class="fitment-wrap" data-title="' + esc(p.title) + '" data-tags="' + esc((p.tags || []).join(',')) + '" data-vendor="' + esc(p.vendor) + '" data-type="' + esc(p.type) + '">' +
      '<article class="product-card"><div class="product-card__image-wrap">' +
        '<a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="400" height="400" loading="lazy">' : '<span class="lk-image-placeholder">Image unavailable</span>') + '</a>' +
        '<span class="lk-fits-badge lk-fitment-badge--' + (ok ? 'verified' : 'suggested') + '">' + (ok ? '✓ Fits your vehicle' : 'Suggested fit · Verify') + '</span>' +
        '<a class="product-card__quick-add product-card__quick-add--link" href="' + esc(p.url) + '">View details &amp; fitment</a>' +
      '</div><div class="product-card__info">' +
        '<div class="product-card__vendor">' + esc(p.vendor) + '</div>' +
        '<a class="product-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="product-card__price"><span class="price' + (sale ? ' price--sale' : '') + '">' + money(p.price) + '</span>' + (sale ? '<span class="price price--compare">' + money(p.compare) + '</span>' : '') + '</div>' +
        '<div class="product-card__buyer-info"><span class="product-card__meta-item">SKU ' + esc(p.sku || 'See options') + '</span><span class="product-card__meta-item product-card__stock">Available to order</span></div>' +
      '</div></article></div>';
  }

  // Best sellers first, green (manufacturer-listed) fits ahead of amber, max 2 per part type so it isn't 8 air filters
  function pickTop(fits) {
    fits.sort(function (a, b) { return (a.c === 'verified' ? 0 : 1) - (b.c === 'verified' ? 0 : 1) || a.i - b.i; });
    var out = [], perType = {}, rest = [];
    fits.forEach(function (f) {
      var t = typeKey(f.p);
      if (out.length < TOP_COUNT && (perType[t] || 0) < TOP_PER_TYPE) { perType[t] = (perType[t] || 0) + 1; out.push(f); }
      else rest.push(f);
    });
    while (out.length < TOP_COUNT && rest.length) out.push(rest.shift());
    return out;
  }

  function topSellers() {
    var sec = document.querySelector('[data-lkp-topsellers]');
    if (!sec) return;
    var grid = sec.querySelector('.grid');
    var eyebrow = sec.querySelector('.section-label');
    var title = sec.querySelector('.section-title');
    var viewAll = sec.querySelector('[data-lkp-viewall]');
    if (!grid || !eyebrow || !title || !viewAll) { sec.classList.remove('is-matching'); return; }
    if (!sec._orig) sec._orig = { grid: grid.innerHTML, eyebrow: eyebrow.textContent, title: title.textContent, href: viewAll.getAttribute('href') };
    var run = sec._run = (sec._run || 0) + 1;

    function restore() {
      if (run !== sec._run) return;
      grid.innerHTML = sec._orig.grid;
      eyebrow.textContent = sec._orig.eyebrow;
      title.textContent = sec._orig.title;
      viewAll.setAttribute('href', sec._orig.href);
      sec.classList.remove('is-matching', 'is-vehicle');
    }

    var v = activeVehicle();
    if (!v || !window.LKFilter || !window.LKGarage.targetCollectionForVehicle) { restore(); return; }
    sec.classList.add('is-matching');
    var handle = window.LKGarage.targetCollectionForVehicle(v) || 'all';
    var fits = [], seen = {}, index = 0;

    function load(page) {
      return bestSellerPage(handle, page).then(function (d) {
        if (run !== sec._run) return null;
        d.products.forEach(function (p) {
          var i = index++;
          if (!p.available || seen[p.id]) return;
          seen[p.id] = 1;
          var c = fitOf(p, v);
          if (c) fits.push({ p: p, c: c, i: i });
        });
        var enough = pickTop(fits.slice()).length >= TOP_COUNT && fits.filter(function (f) { return f.c === 'verified'; }).length >= TOP_COUNT / 2;
        if (!enough && d.next && page < TOP_MAX_PAGES) return load(page + 1);
        return fits;
      });
    }

    load(1).then(function (all) {
      if (!all || run !== sec._run) return;
      if (all.length < 4) { restore(); return; }
      grid.innerHTML = pickTop(all).map(function (f) { return topCard(f.p, f.c); }).join('');
      eyebrow.textContent = 'Top sellers for your truck';
      title.textContent = 'Parts for your ' + vehicleLabel(v);
      viewAll.setAttribute('href', window.LKGarage.targetUrlForVehicle ? window.LKGarage.targetUrlForVehicle(v) : '/collections/' + handle);
      sec.classList.add('is-vehicle');
      sec.classList.remove('is-matching');
    }).catch(restore);
  }

  /* -- 2. Cart drawer "You may also need" -- */
  var UPSELL_COUNT = 3;
  var upsellRun = 0;
  var productCache = {};

  function productJson(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
      productCache[handle].catch(function () { delete productCache[handle]; });
    }
    return productCache[handle];
  }
  function fromShopifyProduct(p) {
    var variant = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    return {
      id: p.id, title: p.title, vendor: p.vendor, type: p.type, tags: p.tags || [],
      price: variant.price != null ? variant.price : p.price, compare: p.compare_at_price || 0,
      image: p.featured_image || (p.images && p.images[0]) || '', url: p.url || ('/products/' + p.handle),
      available: !!p.available, variantId: variant.id
    };
  }
  function related(productId) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return (d.products || []).map(fromShopifyProduct); })
      .catch(function () { return []; });
  }
  // Engine-generation tags (gen-dm-lml, gen-cu-24v...) are the "same truck" test when no truck is saved
  function genTags(tags) {
    return (tags || []).map(function (t) { return String(t).toLowerCase(); }).filter(function (t) { return t.indexOf('gen-') === 0; });
  }
  var PLATFORM_COLLECTION = { 'fit-duramax': 'duramax', 'fit-cummins': 'cummins', 'fit-powerstroke': 'powerstroke-1', 'fit-power-stroke': 'powerstroke-1' };
  function platformCollection(tags) {
    var list = (tags || []).map(function (t) { return String(t).toLowerCase(); });
    for (var i = 0; i < list.length; i++) if (PLATFORM_COLLECTION[list[i]]) return PLATFORM_COLLECTION[list[i]];
    return '';
  }

  function upsell() {
    var box = document.getElementById('lkp-upsell');
    if (!box) return;
    var run = ++upsellRun;
    function hide() { if (run === upsellRun) { box.hidden = true; box.innerHTML = ''; } }

    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (run !== upsellRun) return;
      if (!cart.item_count) { hide(); return; }

      var inCart = {}, types = {}, maxPrice = 0;
      cart.items.forEach(function (it) {
        inCart[it.product_id] = 1;
        types[String(it.product_type || '').toLowerCase().trim()] = 1;
        maxPrice = Math.max(maxPrice, it.final_price || it.price || 0);
      });
      // Add-ons, not a second big part: up to $250, or half the priciest item in the cart
      var cap = Math.max(25000, Math.round(maxPrice * 0.5));
      var lead = cart.items[0]; // most recently added line
      var v = activeVehicle();

      var leadP = productJson(lead.handle).catch(function () { return null; });
      // Best sellers for the saved truck; with no truck, best sellers of the cart part's platform (Duramax / Cummins / Power Stroke)
      var sellersP = (v && window.LKGarage.targetCollectionForVehicle)
        ? bestSellerPage(window.LKGarage.targetCollectionForVehicle(v) || 'all', 1).then(function (d) { return d.products; }).catch(function () { return []; })
        : leadP.then(function (lp) {
            var h = lp && platformCollection(lp.tags);
            return h ? bestSellerPage(h, 1).then(function (d) { return d.products; }).catch(function () { return []; }) : [];
          });

      return Promise.all([related(lead.product_id), leadP, sellersP]).then(function (res) {
        if (run !== upsellRun) return;
        var rel = res[0] || [], leadProduct = res[1], sellers = res[2] || [];
        var leadGens = leadProduct ? genTags(leadProduct.tags) : [];
        var leadPlatform = leadProduct && window.LKFilter && window.LKFilter.textPlatform ? window.LKFilter.textPlatform(leadProduct.title) : '';
        var leadYears = leadProduct && window.LKFilter && window.LKFilter.parseYearRanges ? window.LKFilter.parseYearRanges(upYears(leadProduct.title)) : [];
        // Best sellers first, then Shopify's related products
        var pool = sellers.concat(rel);
        var seen = {}, picks = [];
        pool.forEach(function (p, i) {
          if (!p || seen[p.id] || inCart[p.id] || !p.available) return;
          seen[p.id] = 1;
          if (types[typeKey(p)]) return;
          if (!(p.price > 0) || p.price > cap) return;
          var c;
          if (v) {
            c = fitOf(p, v);
            if (!c) return;
          } else {
            // No saved truck: only parts for the same engine generation as the cart part (no "Fits" badge, shopper confirms on the product page)
            // ...and named for the same diesel platform (guards against mis-tagged parts, e.g. a gas LS bearing tagged Duramax)
            var mine = genTags(p.tags);
            if (!leadGens.length || !mine.some(function (t) { return leadGens.indexOf(t) !== -1; })) return;
            if (!leadPlatform || window.LKFilter.textPlatform(p.title) !== leadPlatform) return;
            // ...and, when both titles give model years, the years must overlap (no 19-23 fog lights for an 11-18 part)
            var years = window.LKFilter.parseYearRanges(upYears(p.title));
            if (leadYears.length && years.length && !years.some(function (a) { return leadYears.some(function (b) { return a.start <= b.end && b.start <= a.end; }); })) return;
            c = 'related';
          }
          picks.push({ p: p, c: c, i: i });
        });
        picks.sort(function (a, b) { return (a.c === 'verified' ? 0 : 1) - (b.c === 'verified' ? 0 : 1) || a.i - b.i; });
        var out = [], perType = {};
        picks.forEach(function (x) {
          var t = typeKey(x.p);
          if (out.length < UPSELL_COUNT && !perType[t]) { perType[t] = 1; out.push(x); }
        });
        if (!out.length) { hide(); return; }

        box.innerHTML =
          '<div class="lkp-upsell__head">You may also need' + (v ? '<span>for your ' + esc(vehicleLabel(v)) + '</span>' : '') + '</div>' +
          out.map(function (x) {
            var p = x.p;
            return '<div class="lkp-upsell__item">' +
              '<a class="lkp-upsell__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(thumb(p.image, 120)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>' +
              '<div class="lkp-upsell__info">' +
                '<a class="lkp-upsell__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
                '<div class="lkp-upsell__meta"><span class="lkp-upsell__price">' + money(p.price) + '</span>' +
                  (x.c === 'verified' ? '<span class="lkp-upsell__fit">✓ Fits</span>' : '') + '</div>' +
              '</div>' +
              '<button type="button" class="lkp-upsell__add" data-lkp-add="' + esc(String(p.url).split('?')[0]) + '"' + (p.variantId ? ' data-variant="' + p.variantId + '"' : '') + ' aria-label="Add ' + esc(p.title) + ' to cart">Add</button>' +
            '</div>';
          }).join('');
        box.hidden = false;
      });
    }).catch(hide);
  }

  function addToCart(btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var vid = btn.getAttribute('data-variant');
    var handle = String(btn.getAttribute('data-lkp-add') || '').replace(/^.*\/products\//, '');
    var getId = vid ? Promise.resolve(vid) : productJson(handle).then(function (p) { return fromShopifyProduct(p).variantId; });
    getId.then(function (id) {
      if (!id) throw new Error('no variant');
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      btn.textContent = 'Added ✓';
      btn.classList.add('is-added');
      // Re-open the drawer: theme.js re-reads the cart, redraws the lines and the count; the observer then refreshes these add-ons
      var opener = document.querySelector('[data-cart-open]');
      if (opener) opener.click();
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Retry';
    });
  }

  function initUpsell() {
    var drawer = document.getElementById('cart-drawer');
    var items = drawer && drawer.querySelector('.cart-drawer__items');
    if (!drawer || !items || !document.getElementById('lkp-upsell')) return;
    var timer;
    function soon() {
      if (!drawer.classList.contains('open')) return;
      clearTimeout(timer);
      timer = setTimeout(upsell, 200);
    }
    new MutationObserver(soon).observe(items, { childList: true });
    new MutationObserver(soon).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lkp-add]');
      if (!b) return;
      e.preventDefault();
      addToCart(b);
    });
  }

  /* -- 3. Phone footer accordions -- */
  function initFooter() {
    var footer = document.querySelector('.site-footer');
    if (!footer || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 768px)');
    var cols = [].slice.call(footer.querySelectorAll('.footer-col')).filter(function (c) {
      return c.querySelector('.footer-col__title') && c.querySelector('.footer-col__links');
    });
    if (!cols.length) return;

    cols.forEach(function (col, i) {
      var t = col.querySelector('.footer-col__title');
      var links = col.querySelector('.footer-col__links');
      if (!links.id) links.id = 'lkp-fcol-' + i;
      function toggle() {
        if (!mq.matches) return;
        var open = col.classList.toggle('is-open');
        t.setAttribute('aria-expanded', String(open));
      }
      t.addEventListener('click', toggle);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    function apply() {
      footer.classList.toggle('lkp-facc', mq.matches);
      cols.forEach(function (col) {
        var t = col.querySelector('.footer-col__title');
        if (mq.matches) {
          t.setAttribute('role', 'button');
          t.setAttribute('tabindex', '0');
          t.setAttribute('aria-controls', col.querySelector('.footer-col__links').id);
          t.setAttribute('aria-expanded', String(col.classList.contains('is-open')));
        } else {
          ['role', 'tabindex', 'aria-controls', 'aria-expanded'].forEach(function (a) { t.removeAttribute(a); });
        }
      });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
  }

  /* -- boot -- */
  function boot() {
    initFooter();
    initUpsell();
    topSellers();
    document.addEventListener('lk:garageChanged', topSellers);
    document.addEventListener('lk:garageCleared', topSellers);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
